import {Stack} from "@mui/material";
import {LanguageSwitcher} from "@variocube/app-ui";
import React from "react";
import {SUPPORTED_LANGUAGES, useLocalization} from "@smalox/shared";
import {TenantIndicator} from "./TenantIndicator";
import {UserMenu} from "./UserMenu";

export function TopNav() {
	const {language, setLanguage} = useLocalization();

	return (
		<Stack
			direction="row"
			spacing={1}
			displayPrint="none"
			sx={{flex: 1}}
			justifyContent="flex-end"
			alignItems="center"
		>
			<TenantIndicator />
			<LanguageSwitcher
				color="inherit"
				languages={SUPPORTED_LANGUAGES}
				language={language}
				setLanguage={setLanguage}
			/>
			<UserMenu />
		</Stack>
	);
}
